const faqData = [
    {
        id: 1,
        question: "What payment methods do you accept?",
        answer: "Our payment methods are either Click or Cash on Delivery. All payments are processed securely through our payment gateway. If the payment is made via Click, you will be contacted on WhatsApp immediately after sending a picture of the transfer to the number"
    },
    {
        id: 2,
        question: "How long does shipping take?",
        answer: "Domestic shipping typically takes 3-5 business days. International shipping can take 7-14 business days depending on the destination. Express shipping options are available at checkout."
    },
    {
        id: 3,
        question: "What is your return policy?",
        answer: "We offer a 30-day return policy for all unused items in their original packaging. Simply contact our customer service team to initiate a return and receive a prepaid shipping label."
    },
    {
        id: 4,
        question: "Do you offer international shipping?",
        answer: "Yes, we ship to most countries worldwide. Shipping costs and delivery times vary by location. You can calculate shipping costs at checkout by entering your delivery address."
    },
    {
        id: 5,
        question: "How can I track my order?",
        answer: "Once your order ships, you'll receive a confirmation email with a tracking number. You can use this number to track your package on our website or the carrier's website."
    }
];

export default faqData;